(function(){
  const $ = (s,c=document)=>c.querySelector(s);
  const $$ = (s,c=document)=>Array.from(c.querySelectorAll(s));

  // === Toast ===
  const toastWrap = $('#ToastWrap');
  window.showToast = function(msg){
    if(!toastWrap) return;
    const t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    toastWrap.appendChild(t);
    setTimeout(()=>{ t.style.opacity='0'; t.style.transition='opacity .3s'; setTimeout(()=>t.remove(),300); }, 2500);
  };

  // === Generic overlay/drawer ===
  function openDrawer(id){
    const d = document.getElementById(id);
    const o = document.getElementById(id+'Overlay');
    if(d) d.classList.add('open');
    if(o) o.classList.add('open');
    document.body.style.overflow='hidden';
  }
  function closeDrawer(id){
    const d = document.getElementById(id);
    const o = document.getElementById(id+'Overlay');
    if(d) d.classList.remove('open');
    if(o) o.classList.remove('open');
    document.body.style.overflow='';
  }

  document.addEventListener('click', (e)=>{
    const open = e.target.closest('[data-open]');
    if(open){ e.preventDefault(); openDrawer(open.dataset.open); if(open.dataset.open==='CartDrawer') refreshCart(); return; }
    const close = e.target.closest('[data-close]');
    if(close){ e.preventDefault(); closeDrawer(close.dataset.close); return; }
    if(e.target.classList && e.target.classList.contains('overlay')){
      const id = e.target.id.replace('Overlay','');
      closeDrawer(id);
    }
  });

  // === Menu submenu navigation ===
  document.addEventListener('click', (e)=>{
    const sub = e.target.closest('[data-submenu]');
    if(sub){ e.preventDefault(); const key = sub.dataset.submenu; $$('.menu-panel').forEach(p=>p.style.display='none'); const target = document.querySelector('.menu-panel[data-panel="'+key+'"]'); if(target) target.style.display='block'; }
    const back = e.target.closest('[data-back]');
    if(back){ e.preventDefault(); const to = back.dataset.back; $$('.menu-panel').forEach(p=>p.style.display='none'); const target = document.querySelector('.menu-panel[data-panel="'+to+'"]'); if(target) target.style.display='block'; }
  });

  // === Automatic real images for hamburger menu rows ===
  const drawerImageCache = new Map();
  function drawerImageFromProduct(product){
    if(!product) return '';
    if(product.featured_image) return typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
    if(product.image) return typeof product.image === 'string' ? product.image : product.image.src;
    if(product.featured_media && product.featured_media.preview_image) return product.featured_media.preview_image.src || '';
    const first = Array.isArray(product.images) ? product.images[0] : null;
    return first ? (typeof first === 'string' ? first : (first.src || first.url || '')) : '';
  }
  function drawerHandleFromUrl(url, marker){
    try{ url = new URL(url, window.location.origin).pathname; } catch(e){}
    const clean = String(url || '').split('?')[0].split('#')[0];
    const part = clean.split(marker)[1];
    return part ? part.split('/').filter(Boolean)[0] : '';
  }
  function drawerSetImage(box, src, title){
    if(!box || !src) return;
    if(src.startsWith('//')) src = window.location.protocol + src;
    box.innerHTML = `<img src="${src}" alt="${title || ''}" loading="lazy" width="60" height="60" onerror="this.remove()">`;
    box.dataset.done = 'true';
  }
  async function drawerFetchJson(url){
    if(drawerImageCache.has(url)) return drawerImageCache.get(url);
    const promise = fetch(url,{headers:{'Accept':'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null);
    drawerImageCache.set(url, promise);
    return promise;
  }
  async function drawerResolveImage(box){
    if(!box || box.dataset.loading === 'true' || box.dataset.done === 'true') return;
    if(box.querySelector('img') && box.dataset.needsImage !== 'true') return;
    box.dataset.loading = 'true';
    const url = box.dataset.autoImage || '';
    const title = box.dataset.autoTitle || box.closest('[data-auto-title]')?.dataset.autoTitle || '';
    let src = '';
    const productHandle = drawerHandleFromUrl(url, '/products/');
    const collectionHandle = drawerHandleFromUrl(url, '/collections/');

    if(productHandle){
      const product = await drawerFetchJson(`/products/${encodeURIComponent(productHandle)}.js`);
      src = drawerImageFromProduct(product);
    }

    if(!src && collectionHandle && collectionHandle !== 'all'){
      const data = await drawerFetchJson(`/collections/${encodeURIComponent(collectionHandle)}/products.json?limit=1`);
      src = drawerImageFromProduct(data && data.products && data.products[0]);
    }

    if(!src && title){
      const data = await drawerFetchJson(`/search/suggest.json?q=${encodeURIComponent(title)}&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=last`);
      const product = data && data.resources && data.resources.results && data.resources.results.products && data.resources.results.products[0];
      src = drawerImageFromProduct(product);
    }

    if(src) drawerSetImage(box, src, title);
    box.dataset.loading = 'false';
  }
  function fillDrawerImages(root){
    $$('[data-auto-image]', root || document).forEach(drawerResolveImage);
  }
  window.ESNFillDrawerImages = () => fillDrawerImages(document);
  document.addEventListener('click', (e)=>{
    if(e.target.closest('[data-submenu]')) setTimeout(()=>fillDrawerImages(document.getElementById('MenuDrawer')), 0);
  });
  fillDrawerImages(document.getElementById('MenuDrawer') || document);

  // === Accordion (PDP description) ===
  document.addEventListener('click', (e)=>{
    const a = e.target.closest('[data-accordion]');
    if(a){ a.parentElement.classList.toggle('open'); }
  });

  // === Variant selector (PDP) ===
  document.addEventListener('click', (e)=>{
    const h = e.target.closest('[data-variant-toggle]');
    if(h){ h.parentElement.classList.toggle('open'); }
    const item = e.target.closest('[data-variant-id]');
    if(item){
      const id = item.dataset.variantId;
      const title = item.dataset.variantTitle;
      const price = item.dataset.variantPrice;
      const idInput = $('#ProductVariantId');
      const nameEl = $('#ProductVariantName');
      const priceEl = $('#ProductPrice');
      if(idInput) idInput.value = id;
      if(nameEl) nameEl.textContent = title;
      if(priceEl && price) priceEl.textContent = price;
      $$('.pdp__variant-item').forEach(b=>b.classList.toggle('active', b===item));
      item.closest('.pdp__variant').classList.remove('open');
    }
  });

  // === Add to cart via AJAX (PDP form) ===
  document.addEventListener('submit', async (e)=>{
    const form = e.target;
    if(!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const fd = new FormData(form);
    const btn = form.querySelector('[type="submit"]');
    const orig = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Hinzufügen…'; }
    try{
      const res = await fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});
      if(!res.ok) throw new Error('add failed');
      showToast('In den Warenkorb gelegt');
      openDrawer('CartDrawer'); refreshCart();
    }catch(err){ showToast('Fehler beim Hinzufügen'); }
    finally{ if(btn){ btn.disabled=false; btn.textContent = orig || 'In den Warenkorb'; } }
  });

  // === Variant Picker (from product card) ===
  const vp = document.getElementById('VariantPicker');
  const vpImg = document.getElementById('VPImg');
  const vpName = document.getElementById('VPName');
  const vpPrice = document.getElementById('VPPrice');
  const vpOptions = document.getElementById('VPOptions');
  const vpConfirm = document.getElementById('VPConfirm');
  let vpProduct = null;
  let vpSelected = {};

  function vpFormat(cents, currency){
    try{ return new Intl.NumberFormat('de-DE',{style:'currency',currency:currency||'EUR'}).format(cents/100); }
    catch(e){ return '€'+(cents/100).toFixed(2).replace('.',','); }
  }
  function vpFindVariant(){
    if(!vpProduct) return null;
    return vpProduct.variants.find(v=>{
      return (v.options||[]).every((val,i)=>{
        const optName = vpProduct.options[i];
        const name = typeof optName === 'string' ? optName : optName.name;
        return vpSelected[name] === val;
      });
    });
  }
  function vpRender(){
    if(!vpProduct) return;
    vpName.textContent = vpProduct.title;
    const img = vpProduct.featured_image || (vpProduct.images && vpProduct.images[0]);
    vpImg.src = img || '';
    vpImg.alt = vpProduct.title;
    const opts = vpProduct.options || [];
    vpOptions.innerHTML = opts.map((opt,i)=>{
      const name = typeof opt === 'string' ? opt : opt.name;
      const values = (typeof opt === 'string')
        ? Array.from(new Set(vpProduct.variants.map(v=>v.options[i])))
        : opt.values;
      const useSelect = values.length > 6;
      if(useSelect){
        return `<div><label class="vp__opt-label">${name}</label>
          <select class="vp__select" data-vp-opt="${name}">
            ${values.map(v=>`<option value="${v}" ${vpSelected[name]===v?'selected':''}>${v}</option>`).join('')}
          </select></div>`;
      }
      return `<div><label class="vp__opt-label">${name}</label>
        <div class="vp__grid">
          ${values.map(v=>`<button type="button" class="vp__pill ${vpSelected[name]===v?'is-selected':''}" data-vp-opt="${name}" data-vp-val="${v}">${v}</button>`).join('')}
        </div></div>`;
    }).join('');
    const variant = vpFindVariant();
    if(variant){
      vpPrice.textContent = vpFormat(variant.price, vpProduct.currency || 'EUR');
      vpConfirm.disabled = !variant.available;
      vpConfirm.textContent = variant.available ? 'Zum Warenkorb' : 'Nicht verfügbar';
    } else {
      vpPrice.textContent = vpFormat(vpProduct.price, vpProduct.currency || 'EUR');
      vpConfirm.disabled = true;
      vpConfirm.textContent = 'Nicht verfügbar';
    }
  }
  function vpOpen(){ vp.classList.add('open'); vp.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function vpClose(){ vp.classList.remove('open'); vp.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }

  document.addEventListener('click', async (e)=>{
    const t = e.target.closest('[data-picker]');
    if(!t) return;
    e.preventDefault(); e.stopPropagation();
    const handle = t.dataset.picker;
    if(!handle || !vp) return;
    try{
      const res = await fetch(`/products/${handle}.js`,{headers:{'Accept':'application/json'}});
      vpProduct = await res.json();
      vpSelected = {};
      const firstAvail = vpProduct.variants.find(v=>v.available) || vpProduct.variants[0];
      if(firstAvail){
        (vpProduct.options||[]).forEach((opt,i)=>{
          const name = typeof opt === 'string' ? opt : opt.name;
          vpSelected[name] = firstAvail.options[i];
        });
      }
      vpRender();
      vpOpen();
    }catch(err){ showToast('Fehler beim Laden'); }
  });
  vp && vp.addEventListener('click', (e)=>{
    if(e.target.closest('[data-vp-close]')){ vpClose(); return; }
    const pill = e.target.closest('.vp__pill');
    if(pill){
      vpSelected[pill.dataset.vpOpt] = pill.dataset.vpVal;
      vpRender();
    }
  });
  vp && vp.addEventListener('change', (e)=>{
    const sel = e.target.closest('.vp__select');
    if(sel){
      vpSelected[sel.dataset.vpOpt] = sel.value;
      vpRender();
    }
  });
  vpConfirm && vpConfirm.addEventListener('click', async ()=>{
    const variant = vpFindVariant();
    if(!variant || !variant.available) return;
    vpConfirm.disabled = true; const orig = vpConfirm.textContent; vpConfirm.textContent = 'Hinzufügen…';
    try{
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
      vpClose();
      showToast('In den Warenkorb gelegt');
      openDrawer('CartDrawer'); refreshCart();
    }catch(err){ showToast('Fehler'); }
    finally{ vpConfirm.disabled = false; vpConfirm.textContent = orig; }
  });

  // === Bundle add ===
  document.addEventListener('click', async (e)=>{
    const t = e.target.closest('[data-bundle-add]');
    if(!t) return;
    e.preventDefault();
    const ids = (t.dataset.bundleAdd||'').split(',').filter(Boolean);
    if(!ids.length) return;
    t.disabled = true; const orig = t.textContent; t.textContent='Hinzufügen…';
    try{
      const items = ids.map(id=>({id:Number(id),quantity:1}));
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      showToast('Bundle in den Warenkorb gelegt');
      openDrawer('CartDrawer'); refreshCart();
    }catch(err){ showToast('Fehler'); }
    finally{ t.disabled=false; t.textContent=orig; }
  });

  // === Cart drawer refresh ===
  const FREE_SHIP_THRESHOLD = 7500; // cents (75 EUR)
  async function refreshCart(){
    const body = $('#CartDrawerBody');
    const footer = $('#CartDrawerFooter');
    const badge = $('#CartBadge');
    if(!body) return;
    body.innerHTML = '<p style="text-align:center;color:#6b7280;padding:40px 0">Laden…</p>';
    const res = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
    const cart = await res.json();
    if(badge){
      if(cart.item_count>0){
        const prev = badge.textContent;
        badge.textContent=cart.item_count;
        badge.style.display='flex';
        if(String(prev)!==String(cart.item_count)){ badge.classList.remove('pop'); void badge.offsetWidth; badge.classList.add('pop'); }
      } else { badge.style.display='none'; }
    }

    const remaining = Math.max(FREE_SHIP_THRESHOLD - cart.total_price, 0);
    const progress = Math.min(100, (cart.total_price / FREE_SHIP_THRESHOLD) * 100);
    const cur = cart.currency || 'EUR';

    const couponHtml = `
      <div class="cd-coupon">
        <label class="cd-label">Code eingeben</label>
        <form class="cd-coupon__row" data-coupon-form>
          <input type="text" name="discount" placeholder="Code" class="cd-input" autocomplete="off"/>
          <button type="submit" class="cd-btn-pill">Anwenden</button>
        </form>
      </div>`;

    const shipHtml = `
      <div class="cd-ship">
        <p class="cd-ship__msg">${remaining>0
          ? `Nur noch <strong>${money(remaining,cur)}</strong> für kostenlosen Versand!`
          : `<strong>Du hast kostenlosen Versand erhalten! 🎉</strong>`}</p>
        <div class="cd-progress"><div class="cd-progress__bar" style="width:${progress}%"></div>
          <div class="cd-progress__dot" style="left:calc(${progress}% - 10px)">📦</div>
        </div>
        <p class="cd-ship__sub">Versandkosten innerhalb Deutschlands: 4,90 €</p>
      </div>`;

    if(cart.item_count===0){
      body.innerHTML = couponHtml + shipHtml + '<div class="cd-empty"><div class="cd-empty__icon">🛒</div><h3>Dein Warenkorb<br/>ist leer.</h3><p>Leg jetzt los und fülle ihn mit<br/>tollen Produkten!</p><a href="/collections/all" class="cd-btn-pill cd-btn-pill--lg" data-close="CartDrawer">Zu den Produkten</a></div>';
      if(footer) footer.innerHTML='';
      return;
    }

    const itemsHtml = cart.items.map((it,i)=>`
      <div class="cd-line" data-key="${it.key}" style="animation-delay:${i*60}ms">
        <div class="cd-line__imgwrap">
          <img src="${it.image||"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 600'%3E%3Crect width='600' height='600' fill='%23f3f4f6'/%3E%3Ctext x='300' y='320' font-size='64' font-weight='900' fill='%239ca3af' font-family='Arial' text-anchor='middle'%3EESN%3C/text%3E%3C/svg%3E"}" alt="${it.product_title||''}" loading="lazy"/>
        </div>
        <div class="cd-line__info">
          <p class="cd-line__title">${it.product_title}</p>
          <p class="cd-line__variant">${it.variant_title||''}</p>
          <p class="cd-line__price">${money(it.final_line_price,cur)}</p>
        </div>
        <div class="cd-line__side">
          <button class="cd-rem" data-remove aria-label="Entfernen">🗑</button>
          <div class="cd-qty">
            <button data-qty="-1" aria-label="Verringern">−</button>
            <span>${it.quantity}</span>
            <button data-qty="1" aria-label="Erhöhen">+</button>
          </div>
        </div>
      </div>
    `).join('');

    body.innerHTML = couponHtml + shipHtml + `<div class="cd-items">${itemsHtml}</div>`;

    footer.innerHTML = `
      <div class="cd-trust">
        <div><span class="cd-trust__ic">🚚</span><span>Versand in 24h</span></div>
        <div><span class="cd-trust__ic">↩︎</span><span>30 Tage Rückgabe</span></div>
        <div><span class="cd-trust__ic">🛡</span><span>Sicher bezahlen</span></div>
      </div>
      <div class="cd-total"><span>Total</span><span class="cd-total__val">${money(cart.total_price,cur)} <small>${cur}</small></span></div>
      <a href="/checkout" class="cd-checkout">🔒 Sicher zur Kasse</a>
      <div class="cd-pay">
        ${['VISA','MC','AMEX','PayPal','Klarna','SEPA','Apple Pay'].map(m=>`<span>${m}</span>`).join('')}
      </div>
    `;

    body.querySelectorAll('.cd-line').forEach(line=>{
      const key = line.dataset.key;
      line.querySelectorAll('[data-qty]').forEach(b=>{
        b.addEventListener('click', async ()=>{
          const delta = Number(b.dataset.qty);
          const curQ = Number(line.querySelector('.cd-qty span').textContent);
          await changeQty(key, curQ + delta);
        });
      });
      line.querySelector('[data-remove]')?.addEventListener('click', ()=>changeQty(key,0));
    });
    body.querySelector('[data-coupon-form]')?.addEventListener('submit', (e)=>{
      e.preventDefault();
      const code = e.target.discount.value.trim();
      if(!code) return;
      window.location.href = '/discount/'+encodeURIComponent(code)+'?redirect=/checkout';
    });
  }
  async function changeQty(key, q){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})});
    refreshCart();
  }
  function money(c, cur){ return new Intl.NumberFormat('de-DE',{style:'currency',currency:cur||'EUR'}).format(c/100); }

  // === Favorite toggle ===
  document.addEventListener('click', (e)=>{
    const b = e.target.closest('[data-fav]');
    if(!b) return;
    e.preventDefault();
    b.classList.toggle('active');
    showToast(b.classList.contains('active') ? 'Zu Favoriten hinzugefügt' : 'Aus Favoriten entfernt');
  });

  // === Copy code (PDP discount) ===
  document.addEventListener('click', async (e)=>{
    const b = e.target.closest('[data-copy]');
    if(!b) return;
    e.preventDefault();
    const txt = b.dataset.copy;
    try{ await navigator.clipboard.writeText(txt); showToast('Code '+txt+' kopiert!'); }
    catch{ showToast('Code: '+txt); }
  });

  // === Lightbox ===
  document.addEventListener('click', (e)=>{
    const b = e.target.closest('[data-lightbox]');
    if(b){
      e.preventDefault();
      const src = b.dataset.lightbox;
      const lb = $('#Lightbox');
      const img = $('#LightboxImg');
      if(lb && img){ img.src = src; lb.classList.add('open'); }
    }
    if(e.target.closest('#Lightbox')){
      const lb = $('#Lightbox');
      if(lb && (e.target.id==='Lightbox' || e.target.closest('.close'))){ lb.classList.remove('open'); }
    }
  });

  // === Category description expand ===
  document.addEventListener('click', (e)=>{
    const b = e.target.closest('[data-expand]');
    if(!b) return;
    const p = $('#'+b.dataset.expand);
    if(!p) return;
    const expanded = p.dataset.expanded === '1';
    if(expanded){ p.textContent = p.dataset.short; p.dataset.expanded='0'; b.textContent='Mehr lesen'; }
    else { p.textContent = p.dataset.full; p.dataset.expanded='1'; b.textContent='Weniger anzeigen'; }
  });

  // === Search modal ===
  document.addEventListener('keydown',(e)=>{
    if(e.key==='Escape'){
      closeDrawer('SearchModal'); closeDrawer('CartDrawer'); closeDrawer('MenuDrawer');
      $('#Lightbox')?.classList.remove('open');
    }
  });

  // === Scroll to top ===
  const toTop = $('#ToTop');
  if(toTop){
    window.addEventListener('scroll', ()=>{
      if(window.scrollY > 400) toTop.classList.add('show'); else toTop.classList.remove('show');
    });
    toTop.addEventListener('click', ()=>window.scrollTo({top:0,behavior:'smooth'}));
  }

  // === Init cart badge on load ===
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json()).then(cart=>{
    const badge = $('#CartBadge');
    if(badge){ if(cart.item_count>0){badge.textContent=cart.item_count;badge.style.display='flex';}else{badge.style.display='none';} }
  }).catch(()=>{});

  // === Newsletter submit (visual only) ===
  document.addEventListener('submit',(e)=>{
    const f = e.target;
    if(f.matches('[data-newsletter]')){
      e.preventDefault();
      showToast('Vielen Dank! Bitte bestätige deine E-Mail.');
      f.reset();
    }
  });
})();
